// Temporary UI gate; the existing server endpoint remains the authority.
const OWNER_ID='1e37afe8-2dcc-4791-802c-8d1323cf477a';
const SUNSET=Date.parse('2026-11-01T04:00:00Z');
function eligible(userId,isAdmin,now=Date.now()){
  return userId===OWNER_ID&&isAdmin===true&&Number.isFinite(now)&&now<SUNSET;
}
async function readRuntimeVersion({userId,isAdmin,getSession,fetcher=fetch,signal,now=Date.now()}){
  if(!eligible(userId,isAdmin,now))throw Error('Runtime check unavailable.');
  const {data:{session}={}}=await getSession();
  if(signal?.aborted||session?.user?.id!==OWNER_ID||!session?.access_token)throw Error('Runtime check unavailable.');
  const response=await fetcher('/api/admin/monitor?view=runtime-version',{
    method:'GET',cache:'no-store',credentials:'same-origin',redirect:'error',signal,
    headers:{Authorization:'Bearer '+session.access_token},
  });
  if(!response.ok)throw Error('Runtime check unavailable.');
  const data=await response.json();
  if(!data||Object.keys(data).length!==1||typeof data.version!=='string'||!/^v\d+\.\d+\.\d+$/.test(data.version))throw Error('Runtime check unavailable.');
  return data.version;
}
module.exports={eligible,readRuntimeVersion,SUNSET};
